import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M2.667 28L16 4l13.334 24H2.667zm3.399-2L16 8.118 25.935 26H6.066zM17 22v2h-2v-2h2zm0-7.333v6h-2v-6h2z" fill="#F9302D" /></svg>);